export enum ShigoFeature {
  Dashboard = 'dashboard',
  Supply = 'supply',
  Demand = 'demand',
  Campaigns = 'campaigns',
  Reporting = 'reporting',
}
